/** CheckBox parser: Control plus text and the checked and disabled flags. */
import { unquoteString } from '../../../../parser/utils';
import { parseControl } from '../control/parser';
import { boolSlotValue } from '../../../../godot/variant/variantBool.js';
export function parseCheckBox(heading, properties) {
    const result = { ...parseControl(heading, properties) };
    if (properties.text !== undefined)
        result.text = unquoteString(properties.text);
    result.buttonPressed = boolSlotValue(properties.button_pressed) === true;
    result.disabled = boolSlotValue(properties.disabled) === true;
    if (properties.button_group !== undefined)
        result.buttonGroup = properties.button_group;
    return result;
}
//# sourceMappingURL=parser.js.map